//LMIT-603
import React, { Component } from 'react';
import './css/adminlanding-page.css';
import AdminWelcome from './adminwelcome.js';
import AdminLogin from './adminlogin.js';

class AdminLandingPage extends Component {
	/*constructor(props){
		super(props);
		console.log("AdminLandingPage()");
	}*/
	componentDidMount() {
	}

	componentWillUnmount() {
	}
	
	doLogin(){
		//console.log("AdminLandingPage doLogin()");
		this.props.ctx.setState( {isAdminLoggedIn : true} );
	}
	
	doLogout(){
		//console.log("AdminLandingPage doLogout()");
		this.props.ctx.setState( {isAdminLoggedIn : false} );
	}
	
	unscheduledOutage(){
		this.loginPage.unscheduledOutage();
	}

	scheduledOutage(){
		this.welcomePage.scheduledOutage();
	}
	
	render() {
		return (
			<div id="adminlanding-page">
				<AdminWelcome ref={ welcomePage => this.welcomePage = welcomePage}/>
				<AdminLogin ctx={this} ref={ loginPage => this.loginPage = loginPage}/>
			</div>
		);
	}
}
export default AdminLandingPage;



// WEBPACK FOOTER //
// ./src/components/adminlanding-page.js